import { useEffect, useState } from "react";
import { es } from "date-fns/locale";
import { Calendar } from "@/components/ui/calendar";
import { api } from "@/lib/api";
import { fromISO, toISO, todayCL } from "@/lib/format";

export const dayOk = (s) => !!s && (s.dia_compartido > 0 || s.dia_privado || s.tinaja_dia);
export const nightOk = (s) => !!s && (s.cabana || s.carpas > 0 || s.rodantes > 0);

const monthKey = (d) => `${d.getFullYear()}-${d.getMonth()}`;

export function AvailabilityCalendar({ mode, date, range, onDate, onRange, avail, setAvail }) {
  const today = fromISO(todayCL());
  const [month, setMonth] = useState(today);
  const [loaded, setLoaded] = useState({});
  const [two, setTwo] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(min-width: 768px)");
    setTwo(mq.matches);
  }, []);
  useEffect(() => {
    const k = monthKey(month);
    if (loaded[k]) return;
    const start = new Date(month.getFullYear(), month.getMonth(), 1);
    const end = new Date(month.getFullYear(), month.getMonth() + 2, 1);
    api.get("/public/availability", { params: { start: toISO(start), end: toISO(end) } }).then((r) => {
      setAvail((a) => ({ ...a, ...r.data.days }));
      setLoaded((l) => ({ ...l, [k]: true }));
    });
  }, [month, loaded, setAvail]);

  const ok = mode === "dia" ? dayOk : nightOk;
  const st = (d) => avail[toISO(d)];
  const modifiers = {
    available: (d) => d >= today && ok(st(d)),
    full: (d) => d >= today && !!st(d) && !ok(st(d)),
  };
  const common = {
    locale: es, month, onMonthChange: setMonth, fromDate: today, numberOfMonths: two ? 2 : 1, modifiers,
    modifiersClassNames: { available: "rl-day-available", full: "rl-day-full" },
    className: "p-0",
    classNames: {
      months: "flex flex-col md:flex-row gap-8",
      head_cell: "text-muted-foreground w-10 sm:w-11 font-medium text-[0.75rem] uppercase",
      cell: "relative p-0 text-center text-sm focus-within:z-20 [&:has([aria-selected])]:bg-[#E9EFE6] first:[&:has([aria-selected])]:rounded-l-full last:[&:has([aria-selected])]:rounded-r-full",
      day: "h-10 w-10 sm:h-11 sm:w-11 rounded-full font-medium transition-colors hover:bg-[#E9EFE6] aria-selected:opacity-100",
      day_selected: "!bg-[#5E6B52] !text-white hover:!bg-[#4A5540]",
      day_range_middle: "aria-selected:!bg-[#E9EFE6] aria-selected:!text-foreground",
      day_today: "ring-1 ring-[#C86D51]",
      caption_label: "font-serif text-lg capitalize",
    },
  };
  return (
    <div data-testid="availability-calendar">
      {mode === "dia" ? (
        <Calendar {...common} mode="single" selected={date ? fromISO(date) : undefined}
          onSelect={(d) => onDate(d ? toISO(d) : null)}
          disabled={[{ before: today }, (d) => !!st(d) && !dayOk(st(d))]} />
      ) : (
        <Calendar {...common} mode="range" selected={range} onSelect={(r) => onRange(r || {})} disabled={[{ before: today }]} />
      )}
      <div className="mt-5 flex flex-wrap gap-5 text-xs text-muted-foreground">
        <span className="flex items-center gap-2"><span className="h-2 w-2 rounded-full bg-[#5E6B52]" />Con disponibilidad</span>
        <span className="flex items-center gap-2"><span className="line-through text-[#C84B31]">15</span>Sin disponibilidad</span>
      </div>
    </div>
  );
}
